import { Component, Input } from '@angular/core';
import { IDemandPrice } from '../../../types/DemandPrice';

@Component({
    selector: 'demand-price',
    templateUrl: './demand-price.component.html',
    styleUrls: ['./demand-price.component.scss'],
    standalone: false
})
export class DemandPriceComponent {
    @Input() public price?: IDemandPrice;
}
